import React from "react";
import { DropsBadge } from "shared/components/Spor";

export const getVehicleLabel = (vehicleStatus: string | null) => {
  switch (vehicleStatus) {
    case "CANCELLED":
      return (
        <DropsBadge m={1} semantics="alarm">
          Kansellert
        </DropsBadge>
      );
    case "PARTIALLY_CANCELLED":
      return (
        <DropsBadge m={1} semantics="warning">
          Delvis kansellert
        </DropsBadge>
      );
    case null:
      return "";
    default:
      return vehicleStatus;
  }
};
